<template>
  <div>
    <p>Här nedanför kan du se diverse information om din Nexa Bridge samt att du har möjlighet att göra vissa inställningar.</p>
    
    <div class="form">
      <div class="item">
        <div class="label">Namn</div>
        <div><input type="text" v-model="$root.data.info.name" @keyup="update"></div>
        <div class="descr">Namnet kommer att sparas automatiskt så fort du skriver, tänk på att döpa din Nexa Bridge till något som gör att du lätt kan identifiera den. Speciellt om du har flera anslutna.</div>
      </div>
      
      <!--
      <div class="item">
        <div class="label">Tid</div>
        <div><input type="text" v-model="$root.data.info.currentTime" @keyup="update"></div>
        <div class="descr">Tiden ställs i de flesta fall in automatiskt men det händer att den ändå blir inkorrekt, då kan du själv korrigera den här ovanför.</div>
      </div>-->

    </div>

    <table>
      <tbody>
        <tr v-for="item in table" class="nohover">
          <td>{{ item.title }}</td>
          <td align="right">{{ $root.data.info[item.key] }}</td>
        </tr>
      </tbody>
    </table>
    
    <hr class="space">
    
    <div class="form">
      <div class="item">
        <button @click="restart" :disabled="rebooting">{{ rebooting ? 'Startar om...' : 'Starta om' }}</button>
      </div>
      
      <div class="item">
        <button @click="logout">Logga ut från webbgränssnittet</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  
  export default {
    name: 'installningar_info',
    data () {
      return {
        writeTimer: null,
        fetchInfoTimer: null,
        table: [
          { title: 'ID', key: 'gwid' },
          //{ title: 'Version', key: 'version' },
          { title: 'Intern IP-adress', key: 'internalIp' },
          { title: 'Soluppgång', key: 'sunrise' },
          { title: 'Solnedgång', key: 'sunset' },
          { title: 'Nuvarande tid', key: 'currentTime' }
        ],
        rebooting: false
      }
    },
    created () {
      this.fetchInfo()
    },
    methods: {
      fetchInfo () {
        HTTP.get('info')
        .then(res => res.data)
        .then(json => {
          this.$root.data.info.currentTime = json.currentTime

          //this.fetchInfoTimer = setTimeout(() => this.fetchInfo(), 5*1000)
        })
      },

      logout () {
        this.$cookie.delete('bridgeId')
        this.$cookie.delete('email')
        this.$cookie.delete('hash')
        this.$cookie.delete('password')
        
        setTimeout(() => window.location.reload(), 1000)
      },

      update () {
        if (this.writeTimer) {
          clearTimeout(this.writeTimer)
        }

        this.writeTimer = setTimeout(() => {
          const name = this.$root.data.info.name
          HTTP.post('info', {
            name: name
          })
        }, 1000)
      },

      restart () {
        if (confirm('Är du säker på att du vill starta om din Nexa Bridge? Detta tar några minuter')) {
          this.rebooting = true

          HTTP.post('actions/restartnx')
          .then(res => res.data)
          .then(json => {
            
          })
        }
      }
    },
    computed: {},
    destroyed () {
      clearTimeout(this.fetchInfoTimer)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_info.vue